import React from 'react';
import {$createFileNode, FileNode, INSERT_FILE_COMMAND} from '../nodes/FileNode';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {INSERT_CARD_COMMAND} from './KoenigBehaviourPlugin';
import {mergeRegister} from '@lexical/utils';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';

export const FilePlugin = () => {
    const [editor] = useLexicalComposerContext();

    React.useEffect(() => {
        if (!editor.hasNodes([FileNode])){
            console.error('FilePlugin: FileNode not registered');
            return;
        }
        return mergeRegister(
            editor.registerCommand(
                INSERT_FILE_COMMAND,
                async (dataset) => {
                    const cardNode = $createFileNode(dataset);
                    editor.dispatchCommand(INSERT_CARD_COMMAND, {cardNode});

                    return true;
                },
                COMMAND_PRIORITY_LOW
            )
        );
    });

    return null;
};

export default FilePlugin;
